import UserApi from 'api/UserApi';
import ApiMapper from 'constant/ApiMapper';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import globalState from 'ui/src/state/globalState';

const ServiceModal = ({
  serviceId,
  status,
  closeServiceModal,
  fetchUserData,
}: {
  serviceId: string;
  status: string;
  closeServiceModal?: () => void;
  fetchUserData?: any;
}) => {
  const [userState, setUserState] = useRecoilState(globalState);
  const [group1, setGroup1] = useState([]); //그룹 종류
  const [selectedGroupId, setSelectedGroupId] = useState(''); //셀렉트박스

  const handleSelectChange = (event) => {
    setSelectedGroupId(event.target.value);
  };
  const mapper = ApiMapper.AUTH;

  const callCarGroup = async () => {
    try {
      const result = await UserApi.CarGroup();
      console.log(result);
      setGroup1(result.data);
      setSelectedGroupId(result.data[0].group_id);
    } catch (e) {
      console.error(e);
      setGroup1([]);
    }
  };

  useEffect(() => {
    callCarGroup();
  }, []);

  //사용 신청하기
  const onSubmit = async () => {
    try {
      const result: any = await UserApi.SUBMIT({
        url: mapper.SUBMIT,
        userId: userState.UserInformation.userId,
        serviceId: serviceId,
        groupId: serviceId === 'VEHICLE' ? selectedGroupId : null,
      });
      console.log(result.status);
      if (result.status === 200) {
        alert('사용 신청이 완료되었습니다. 관리자의 승인까지 기다려주세요.');
        fetchUserData();
        closeServiceModal();
      } else {
        alert('사용 신청에 실패하였습니다. 관리자에게 문의해주세요.');
      }
    } catch (e) {
      alert(e);
    }
  };

  return (
    <>
      <div className="lBox">
        <div className="lTitArea">
          <button
            type="button"
            className="lTitBtn"
            onClick={closeServiceModal}
          >
            <span>레이어창 닫기</span>
          </button>
        </div>

        <div className="lConArea">
          {status === '신청' ? (
            <div className="lConMsg">
              사용 신청 승인 대기 중입니다.
              <br />
              처리가 완료될 까지 기다려주세요.
            </div>
          ) : null}

          {status === '' ? (
            <div className="lConMsg">
              서비스 사용 권한이 없습니다.
              <br />
              사용 신청을 하시겠습니까?
              {serviceId === 'VEHICLE' && (
                <>
                  <br />
                  <br />
                  <a
                    style={{
                      fontSize: '14px',
                    }}
                  >
                    그룹선택 &nbsp;
                  </a>
                  <select
                    value={selectedGroupId}
                    onChange={handleSelectChange}
                  >
                    {group1
                      ? group1.map((item) => (
                          <option
                            key={item.group_id}
                            value={item.group_id}
                          >
                            {item.group_nm}
                          </option>
                        ))
                      : null}
                  </select>
                </>
              )}
            </div>
          ) : null}

          {status === '거절' ? (
            <div className="lConMsg">
              사용 신청이 반려되었습니다.
              <br />
              다시 사용 신청을 하시겠습니까?
            </div>
          ) : null}

          {status === '삭제' ? (
            <div className="lConMsg">
              사용 권한이 관리자에 의해 삭제되었습니다.
              <br />
              다시 사용 신청을 하시겠습니까?
            </div>
          ) : null}

          <div className="lConBottom">
            {status === '거절' || status === '' || status === '삭제' ? (
              <div className="lConBottomRight">
                <button
                  type="button"
                  className="bHeight03 bLineType03"
                  onClick={closeServiceModal}
                >
                  <span>취소</span>
                </button>
                <button
                  type="button"
                  className="bHeight03"
                  onClick={onSubmit}
                >
                  <span>사용 신청하기</span>
                </button>
              </div>
            ) : (
              <div className="lConBottomRight">
                <button
                  type="button"
                  className="bHeight03 bLineType03"
                  onClick={closeServiceModal}
                >
                  <span>닫기</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="lMask"></div>
    </>
  );
};

export default ServiceModal;
